module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAAAGCAYAAABQM8l6AAAAVUlEQVRIS2NkGAVUCQFGzcpNyf//M0ZQxbQRasiNDl9XRo3KTe0M/xkqRmgYUMXbNzr8GEcDkgpBORqQVAhEkBGQgCzfoPufkVGDSmaOSGNudvivBgDGfRoHWjglBAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/shape.png
// module id = QIj8
// module chunks = 3